import { createFileRoute } from "@tanstack/react-router";

import { PaymentHistoryDetail } from "@/features/my/settings/account/billing/payments/payment-history/payment-history-detail";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/payments/history_/$transactionId",
)({
  component: PaymentHistoryDetail,
});
